import { Box, Card, Table, Text } from '@chakra-ui/react'
import { useMemo } from 'react'
import { useTranslation } from '../../i18n'

export function ChallengeBreakdown({ byChallenge }) {
  const { t } = useTranslation()

  const rows = useMemo(() => {
    if (!byChallenge) return []
    return Object.entries(byChallenge)
      .map(([id, data]) => ({
        id,
        label: data.label || id,
        submissions: data.submissions ?? 0,
        accepted: data.accepted ?? 0,
        rejected: data.rejected ?? 0,
      }))
      .sort((a, b) => b.submissions - a.submissions)
  }, [byChallenge])

  if (rows.length === 0) return null

  return (
    <Card.Root bg="var(--mc-bg-surface)" border="1px solid" borderColor="var(--mc-border)">
      <Card.Body>
        <Text fontWeight="semibold" mb={3}>{t('analytics.challengeBreakdownTitle')}</Text>
        <Box overflowX="auto">
          <Table.Root size="sm">
            <Table.Header>
              <Table.Row>
                <Table.ColumnHeader>{t('analytics.colChallenge')}</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="right">{t('analytics.colSubmissions')}</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="right">{t('analytics.colAccepted')}</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="right">{t('analytics.colRejected')}</Table.ColumnHeader>
                <Table.ColumnHeader textAlign="right">{t('analytics.colAcceptRate')}</Table.ColumnHeader>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {rows.map((row) => {
                const rate = row.submissions > 0
                  ? `${Math.round((row.accepted / row.submissions) * 100)}%`
                  : '—'
                return (
                  <Table.Row key={row.id}>
                    <Table.Cell>{row.label}</Table.Cell>
                    <Table.Cell textAlign="right">{row.submissions}</Table.Cell>
                    <Table.Cell textAlign="right">{row.accepted}</Table.Cell>
                    <Table.Cell textAlign="right">{row.rejected}</Table.Cell>
                    <Table.Cell textAlign="right">{rate}</Table.Cell>
                  </Table.Row>
                )
              })}
            </Table.Body>
          </Table.Root>
        </Box>
      </Card.Body>
    </Card.Root>
  )
}
